import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled from 'styled-components';
import { TypeAhead } from '../../..';
import { operatorLabelMap } from '../utils';
var OperatorContainer = styled.div.withConfig({
  displayName: "OperatorComponent__OperatorContainer",
  componentId: "sc-16ptann-0"
})(["margin-top:1.55rem;"]);
export var OperatorComponent = function OperatorComponent(_ref) {
  var stateKey = _ref.stateKey,
      state = _ref.state,
      stateChangeFn = _ref.stateChangeFn,
      operators = _ref.operators,
      dsComponentProps = _ref.dsComponentProps;
  return /*#__PURE__*/React.createElement(OperatorContainer, null, /*#__PURE__*/React.createElement(TypeAhead, {
    e2e: "".concat(dsComponentProps.e2e, "-operator"),
    disableClearable: true,
    options: (operators === null || operators === void 0 ? void 0 : operators.sort(function (a, b) {
      return a.localeCompare(b);
    })) || [],
    value: state[stateKey].operator,
    dsOnChange: function dsOnChange(e, val) {
      return stateChangeFn(_objectSpread(_objectSpread({}, state), {}, _defineProperty({}, stateKey, _objectSpread(_objectSpread({}, state[stateKey]), {}, {
        operator: val
      }))));
    },
    getOptionLabel: function getOptionLabel(operator) {
      return operatorLabelMap[operator];
    }
  }));
};

try {
  OperatorComponent.__docgenInfo = {
    description: '',
    displayName: 'OperatorComponent',
    methods: [],
    props: {}
  };
} catch (e) {}
//# sourceMappingURL=OperatorComponent.js.map